import React from "react";
import { Helmet } from "react-helmet";
import { officeContactDetails, socialLinks } from "config/config";
import { KALYANAWARAN_URL, WEBSITE_NAME } from "constant/footerConst";

const SEO = ({ title, description, link, imageUrl }) => {
  const DEFAULT_OG_IMAGE =
    "https://www.kalyanawaran.com/assets/images/og-logo.png";
  const image = imageUrl || DEFAULT_OG_IMAGE;

  // officeContactDetails is an array, take the first one for the main schema
  const contact = officeContactDetails[0];
  const sameAsLinks = socialLinks.map((item) => item.link);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: WEBSITE_NAME,
    url: KALYANAWARAN_URL,
    image: image,
    telephone: contact.phone,
    email: contact.emailId,
    address: {
      "@type": "PostalAddress",
      streetAddress: `${contact.addressFirstLine}${
        contact.addressSecondLine ? ", " + contact.addressSecondLine : ""
      }`,
      addressLocality: contact.city,
      postalCode: contact.pinCode,
      addressCountry: "IN",
    },
    sameAs: sameAsLinks,
  };

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={link} />
      <meta name="author" content="kalyanawaran - A Matrimony website." />
      <meta name="image" content={image} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Schema.org markup for Local Business */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
